import { render, staticRenderFns } from "./GroupCancel.vue?vue&type=template&id=db8e05bc&scoped=true&"
import script from "./GroupCancel.vue?vue&type=script&lang=js&"
export * from "./GroupCancel.vue?vue&type=script&lang=js&"
import style0 from "./GroupCancel.vue?vue&type=style&index=0&id=db8e05bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e05bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
